"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var DataConnect = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M6.5,4 C7.70932545,4 8.71809967,4.85866183 8.94990271,5.99956551 L12,6 C13.7495444,6 15,7.28045498 15,9 C15,10.3828252 14.1192021,11.4999055 12.4474459,12.3389249 L12.2145849,12.4516119 C10.7052856,13.1687606 10,14.0151033 10,15 C10,16.1393588 10.7513978,16.9258921 11.8419449,16.9950411 L12,17 L15.0500973,16.9995655 C15.2819003,15.8586618 16.2906746,15 17.5,15 C18.8807119,15 20,16.1192881 20,17.5 C20,18.8807119 18.8807119,20 17.5,20 C16.2903182,20 15.2813059,19.1408321 15.0498926,17.999426 L12,18 C10.2773328,18 9,16.7509773 9,15 C9,13.6337985 9.87596912,12.5205355 11.5447527,11.667074 L11.7885346,11.546919 C13.2960236,10.8433324 14,9.99856077 14,9 C14,7.88079858 13.2636794,7.07594037 12.1601111,7.00508384 L12,7 L8.9501074,6.99942595 C8.7186941,8.14083211 7.70968176,9 6.5,9 C5.11928813,9 4,7.88071187 4,6.5 C4,5.11928813 5.11928813,4 6.5,4 Z M17.5,16 C16.8313991,16 16.2528861,16.4412441 16.0643885,17.0628139 L16.0300751,17.1986724 L15.968,17.501 L16.0299527,17.8007246 C16.1609795,18.4469917 16.7037729,18.9315957 17.3581726,18.9933372 L17.5,19 C18.3284271,19 19,18.3284271 19,17.5 C19,16.6715729 18.3284271,16 17.5,16 Z M6.5,5 C5.67157288,5 5,5.67157288 5,6.5 C5,7.32842712 5.67157288,8 6.5,8 C7.16881208,8 7.74745781,7.55848051 7.93577698,6.93664079 L7.97004731,6.80072461 L8.031,6.501 L7.96992493,6.19867243 C7.83867405,5.55267303 7.29598438,5.0683623 6.64178342,5.00665865 L6.5,5 Z" })));
};
DataConnect.displayName = 'DataConnect';
exports.default = DataConnect;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=DataConnect.js.map